var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "互动脚本延时时间",
        width: "620px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "InteractiveDelay overflowOuto",
        },
        [
          _c(
            "div",
            { staticClass: "InteractiveDelayForm" },
            [
              _c("span", { staticClass: "InteractiveDelayFormLabel m-r-10" }, [
                _vm._v("互动整体延时时间"),
              ]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "60px" },
                  attrs: { size: "small", placeholder: "请选择" },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
              _c("span", { staticClass: "InteractiveDelayFormLabel m-l-10" }, [
                _vm._v("秒"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "interactiveDelayTips m-t-20" }, [
            _c("span", [_vm._v("提示")]),
            _c("div", { staticClass: "interactiveDelayTipsContent" }, [
              _vm._v(" 1、当调整延时间时，需要注意学员端的互动信息接收情况！"),
              _c("br"),
              _vm._v(
                " 2、数值默认为0秒，数值越大，延时越高，数值越小，延时越小。 "
              ),
            ]),
            _c("div", { staticClass: "example" }, [
              _vm._v(
                " （例如：互动为0:00:15时送鲜花，往后延时5秒，则学员端收到消息的是0:00:20） "
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "ss-material-box-bottom",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading, type: "danger" },
              on: { click: _vm.sure },
            },
            [_vm._v("确定")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }